export default "__VITE_ASSET__BIjFaFQ6__"